// @tennis-matches/services/winterdoppel/publishedChange

import { isWinterDoppelPlanFinal } from "./planLock.js";

export const WINTERDOPPEL_PUBLISHED_PLAYER_CHANGE = Object.freeze({
  UPDATE: "update",
  BLOCKS: "blocks",
  CREATE: "create",
  DELETE: "delete",
});

/**
 * @param {object|null|undefined} series
 * @param {typeof WINTERDOPPEL_PUBLISHED_PLAYER_CHANGE[keyof typeof WINTERDOPPEL_PUBLISHED_PLAYER_CHANGE]} change
 * @param {{ allowPublished?: boolean }} [opts]
 */
export function assertWinterDoppelPlayerChangeAllowed(
  series,
  change,
  { allowPublished = false } = {},
) {
  if (!isWinterDoppelPlanFinal(series)) return;
  if (
    change === WINTERDOPPEL_PUBLISHED_PLAYER_CHANGE.UPDATE ||
    change === WINTERDOPPEL_PUBLISHED_PLAYER_CHANGE.BLOCKS
  ) {
    return;
  }
  if (allowPublished) return;
  throw new Error("winterdoppel.publishedChange.playerBlocked");
}
